module.exports = __webpack_public_path__ + "img/nb-base.33535380.png";